export const FEATURE_FLAGS = {
  SHOW_DIWALI_LOGO: 'show_diwali_logo',
  PULSE_ENABLED: 'pulse_enabled',
};
